
import './select.scss';

const Select = ({ options, value, onChange, children, disabled=false }) => {
    return <select value={value} onChange={onChange} className="select-input" disabled={disabled}>
        {children}
    </select>
}

export default Select;